import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type {
  CreateErfinaProductRequestDto,
  CreateErfinaProductResponseDto
} from "../../dtos/erfina-product-dto";
import { ProductService } from "../../services/product-service";

type UsePostCreateErfinaProductMutationParams = {
  options?: UseMutationOptions<
    CreateErfinaProductResponseDto,
    unknown,
    CreateErfinaProductRequestDto
  >;
};

export const usePostCreateErfinaProductMutation = ({
  options
}: UsePostCreateErfinaProductMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.createErfinaProduct({ payload });
    },
    ...options
  });
};
